import React from "react";
import LegalLayout, { Section } from "./LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="PRIVACY POLICY" updated="June 2026" testid="privacy-page">
      <p>
        This policy explains what information Edge Training ("we", "us") collects, why we collect it,
        who processes it on our behalf, and the choices you have. It reflects how the product currently
        works. Where confirmed business details are still required, you will see <span className="text-amber-400">[PLACEHOLDER]</span>.
      </p>

      <Section heading="1. Who we are">
        <p>
          Edge Training is a coaching and training-management platform operated by{" "}
          <span className="text-amber-400">[PLACEHOLDER: legal business name]</span>,{" "}
          <span className="text-amber-400">[PLACEHOLDER: registered address]</span>. For any privacy
          question or request, contact <span className="text-amber-400">[PLACEHOLDER: privacy contact email]</span>.
        </p>
      </Section>

      <Section heading="2. Information we collect">
        <ul className="list-disc pl-5 space-y-1">
          <li><b>Account details</b> — name, email, password (stored only as a salted hash) or Google sign-in profile, and your selected role.</li>
          <li><b>Profile & training data</b> — bio, height/weight, units, timezone, workouts, personal records, goals, nutrition and recovery/readiness logs, and pain reports you choose to submit.</li>
          <li><b>Coaching data</b> — programs, assignments, assessments, messages and attachments between you and a linked coach, team memberships and leaderboard activity.</li>
          <li><b>Media you upload</b> — form-check photos/videos and documents, stored to provide the feature.</li>
          <li><b>Payment metadata</b> — plan, amount, order/payment identifiers and status. We do not store card numbers; card data is handled by our payment processor.</li>
          <li><b>Technical data</b> — sign-in events (timestamp, IP, user agent) for security, and notification/push subscription tokens if you enable them.</li>
        </ul>
      </Section>

      <Section heading="3. Why we use it">
        <p>
          To provide and operate the service (training, coaching, messaging, progress tracking), to process
          subscriptions, to keep accounts secure, to send notifications you have enabled, and to respond to
          support requests. We do not sell your personal data.
        </p>
      </Section>

      <Section heading="4. Service providers & AI processing">
        <ul className="list-disc pl-5 space-y-1">
          <li><b>Database & file hosting</b> — MongoDB and Emergent Object Storage store your account, training and uploaded media.</li>
          <li><b>AI features</b> — the AI Program Designer and AI Form Check send the relevant prompt or image to a third-party AI provider (via the Emergent LLM gateway, using models from Anthropic, OpenAI or Google) to generate a response. AI output can be wrong and is provided for review, not as instruction. Do not submit sensitive personal information you do not want processed by an AI provider.</li>
          <li><b>Payments</b> — Razorpay processes checkout and holds payment-instrument data under its own privacy terms.</li>
          <li><b>Email</b> — Resend delivers transactional/lead emails when configured.</li>
        </ul>
      </Section>

      <Section heading="5. Retention & deletion">
        <p>
          We keep your data while your account is active. You can download a copy of your data at any time
          from <b>Profile → Your Data &amp; Privacy</b>, and you can request deletion of your account from the
          same place. Deleting your account permanently removes your personal records and detaches you from
          coaches, teams and guardians. Shared records that belong to other people or to an academy (for
          example, a team you do not own) are retained. Some records may be kept where required for legal,
          accounting or fraud-prevention reasons: <span className="text-amber-400">[PLACEHOLDER: retention periods]</span>.
        </p>
      </Section>

      <Section heading="6. Guardians & young athletes">
        <p>
          A parent or guardian can only view an athlete's data after the athlete accepts a link request in
          their own account — knowing a name or email alone grants no access. Our position on accounts for
          users under 18 is described in the Terms. <span className="text-amber-400">[PLACEHOLDER: confirm minimum age and guardian-consent process]</span>.
        </p>
      </Section>

      <Section heading="7. Your choices">
        <p>
          You can edit your profile, control notification preferences, export your data, and delete your
          account at any time. Depending on where you live you may have additional rights (access, correction,
          erasure, portability). To exercise them, contact <span className="text-amber-400">[PLACEHOLDER: privacy contact email]</span>.
        </p>
      </Section>

      <Section heading="8. Security">
        <p>
          Passwords are hashed, sessions are token-based and can be revoked, and access to coaching data is
          restricted to authorised relationships. No system is perfectly secure; please use a strong, unique
          password.
        </p>
      </Section>

      <Section heading="9. Changes">
        <p>We may update this policy; we will change the "last updated" date above when we do.</p>
      </Section>
    </LegalLayout>
  );
}
